// extracted by mini-css-extract-plugin
module.exports = {"displayImg":"style_displayImg__TUdgZ","overflow":"style_overflow__DTHlb","imgWrapper":"style_imgWrapper__RQPbI","transition":"style_transition__VmYz_"};